module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch1"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('p', {
    staticClass: "centerImage0"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/ch1.jpg",
      "width": "4%"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "id": "pg-1"
    }
  }, [_vm._v("“How did you get in here?” a voice calls as you enter the waiting room at Eeek Laboratories. “That door is supposed to be locked at all times.”")])]), _c('a', {
    attrs: {
      "id": "pg-1"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("You and your friend Sam jump. You didn’t think anyone was around.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Then you spot the receptionist sitting behind a tall desk. She’s a short, frizzy-haired redhead wearing too much lipstick for her thin lips. She glares at you as if she expects you to turn around and leave — as soon as you figure out you’re in the wrong place.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m looking for my mom,” you tell her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Who’s your mom?” the receptionist asks. She starts to pack up her things to leave.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("You glance at the clock. It’s almost five-thirty — quitting time.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“She’s the new lab technician,” you explain. “She’s working on some top secret experiments for Eeek.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Really? For "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dr")]), _vm._v(". Eeek?” The receptionist gazes at you suspiciously.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yeah — I guess,” you say.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But really, you’re not sure. How come your mom never mentioned him before? Dr. Eeek? All she ever told you was that she had a new job in a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("research")]), _vm._v(" lab. You didn’t know there was a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("medical")]), _vm._v(" doctor involved. Doctors give you the creeps.")])]), _c('p', {
    staticClass: "extractLetterText",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "pg-1"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Go on to")])]), _c('a', {
    attrs: {
      "href": "#/e9780545841054_ch002"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("PAGE 2")])]), _vm._v(".")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d9835e98","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9780545841054_ch001.vue
// module id = 66
// module chunks = 0